import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bd4da236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_3 = { class: "description-text" }

import { DescriptionTextProps } from './description.ts'


export default /*#__PURE__*/_defineComponent({
  __name: 'description-text',
  props: {
    title: {},
    content: {},
    btnText: { default: '了解详情' },
    showbtn: { type: Boolean }
  },
  emits: ["detail"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit
const handleClick = () => {
  emit('detail')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (item, index) => {
        return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item), 1))
      }), 128)),
      (_ctx.showbtn)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: handleClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.btnText), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})